module.exports = __webpack_public_path__ + "static/media/error.520c47b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.svg
// module id = 674
// module chunks = 21